import { render, staticRenderFns } from "./ListCouponsView.vue?vue&type=template&id=72ba3c52"
import script from "./ListCouponsView.vue?vue&type=script&lang=js"
export * from "./ListCouponsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports